import { Streamdown } from "streamdown"

import type { CoviActionItem } from "../model/types"
import { toolLabel, toolState, toolStatusLabel } from "../utils/toolSteps"
import { SOFIA_MARKDOWN_COMPONENTS } from "./SofiaMarkdownLink"

export function ActionCardFeedback({
  item,
  hideExplanation = false,
}: {
  item: CoviActionItem
  hideExplanation?: boolean
}) {
  const feedback = item.feedback
  if (!feedback || item.status === "executing") {
    return null
  }
  const failedSteps =
    feedback.steps?.filter((step) => toolState(step) === "failed") ?? []
  const showExplanation =
    !!feedback.text &&
    (!hideExplanation || item.status === "error" || failedSteps.length > 0)
  if (!showExplanation && !feedback.warning && failedSteps.length === 0) {
    return null
  }
  return (
    <div
      className="mt-3 space-y-2 border-t border-coval-border pt-3 text-sm text-coval-text"
      aria-live="polite"
    >
      {feedback.warning ? (
        <p className="text-coval-text-muted">{feedback.warning}</p>
      ) : null}
      {showExplanation ? (
        <details open={item.status === "error"}>
          <summary className="cursor-pointer text-xs font-medium text-coval-text-muted">
            Sofia’s explanation
          </summary>
          <Streamdown
            components={SOFIA_MARKDOWN_COMPONENTS}
            className="mt-2 break-words text-sm leading-relaxed [&_p]:mb-2 [&_p:last-child]:mb-0 [&_a]:text-coval-info-text [&_a]:underline"
          >
            {feedback.text}
          </Streamdown>
        </details>
      ) : null}
      {failedSteps.length ? (
        <ul className="space-y-1 text-xs text-coval-danger-text">
          {failedSteps.map((step, index) => (
            <li key={`${step.name}-${index}`}>
              {toolLabel(step.name, step)} —{" "}
              {toolStatusLabel(step.status) ?? "Failed"}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
